import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import { ReduxProvider } from "./redux/provider"
import { BrowserRouter } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { GoogleOAuthProvider } from "@react-oauth/google"
import * as Sentry from "@sentry/react"

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: 0.2,
  // Record a replay only when an error occurs
  replaysOnErrorSampleRate: 1.0,
  replaysSessionSampleRate: 0,
})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
  <Sentry.ErrorBoundary fallback={<p>Something went wrong. Please refresh the page.</p>}>
    <HelmetProvider>
      <BrowserRouter>
        <ReduxProvider>
          <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID as string}>
            <App />
          </GoogleOAuthProvider>
        </ReduxProvider>
      </BrowserRouter>
    </HelmetProvider>
  </Sentry.ErrorBoundary>
)
